import {mapMutations, mapGetters, mapActions} from "vuex";

export default {
    name: "product-question",
    props: {},
    data() {
        return {
            payload: {
                message: '',
                product_id: '',
                guest_name: '',
                phone: '',
            },
            errors: {
                guest_name: '',
                phone: '',
                message: '',
            }
        }
    },
    watch: {
        'payload.message'() { this.errors.message = '' },
        'payload.guest_name'() { this.errors.guest_name = '' },
        'payload.phone'() { this.errors.phone = '' },
    },
    created() {
        this.payload.product_id = this.currentProduct.id
        if (this.questionId) {
            this.payload.parent_id = this.questionId
        }
    },
    computed: {
        ...mapGetters({
            currentProduct: 'catalog/currentProduct',
            questionId: 'card/questionId',
            isAuthenticated: 'auth/isAuthenticated',
        })
    },
    methods: {
        ...mapActions({
            sendQuestion: 'card/WRITE_QUESTION',
        }),
        ...mapMutations({
            closeQuestionPopup: 'card/SHOW_QUESTION_POPUP'
        }),
        sendUserQuestion() {
            this.errors = { guest_name: '', phone: '', message: '' }
            let hasError = false
            if (!this.isAuthenticated && !this.payload.guest_name.trim()) {
                this.errors.guest_name = "Введіть ваше ім'я"
                hasError = true
            }
            if (!this.payload.phone.trim()) {
                this.errors.phone = 'Введіть номер телефону'
                hasError = true
            }
            if (!this.payload.message.length) {
                this.errors.message = this.$t('callback.enterText')
                hasError = true
            } else if (this.payload.message.length <= 10) {
                this.errors.message = this.$t('validation.minLength', {'size': 10})
                hasError = true
            }
            if (!hasError) {
                const sendData = Object.assign({}, this.payload)
                sendData.page_url = typeof window !== 'undefined' ? window.location.href : ''
                if (this.isAuthenticated) {
                    delete sendData.guest_name
                }
                this.sendQuestion(sendData).then(() => {
                    this.$toasted.success(this.$t('productCard.questions.success'));

                    if (typeof window !== 'undefined' && window.dataLayer) {
                        window.dataLayer.push({ event: 'question_callback_form' });
                    }

                    this.closeQuestionPopup(false)
                    document.getElementById('html').classList.remove('hide')
                }).catch(error => {
                    this.$toasted.error('error', error);
                })
            }
        }
    },
}
